import { GET_CATEGORIES_FAILURE, GET_CATEGORIES_REQUEST, GET_CATEGORIES_SUCCESS } from 'actions/shared.types';

const initState = () => ({
  categories: [],
  errorMessage: '',
  isFetching: false,
  isPosting: false,
  isSaved: false,
  areCategoriesFetched: false,
  serviceTemplates: [],
});

const salonServicesReducer = (state = initState(), action) => {
  if (action && action.type) {
    switch (action.type) {
      case GET_CATEGORIES_REQUEST: {
        return { ...state, isFetching: true };
      }
      case GET_CATEGORIES_SUCCESS: {
        return {
          ...state,
          categories: action.response,
          isFetching: false,
          areCategoriesFetched: true,
        };
      }
      case GET_CATEGORIES_FAILURE: {
        return { ...state, isFetching: false, errorMessage: action.errorMessage };
      }
      default:
        return state;
    }
  }
  return state;
};

export default salonServicesReducer;
